import { SocietyConfiguration } from 'types/Society';

/**
 * Panel deep links (sttok://routeId) in AI answers.
 * Controlled per society: configuration.aiPlan.sectionLinksEnabled (requires aiPlan.enabled).
 */
export const isAiPanelLinksEnabled = (
  configuration?: SocietyConfiguration
): boolean =>
  configuration?.aiPlan?.enabled === true &&
  configuration?.aiPlan?.sectionLinksEnabled === true;
